import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import BackButton from '../../../../components/UI/BackButton';
import AuditFullDetails from './AuditFullDetails';
import { TitleUI, SubtitleUI } from '../../../../components/UI/LabelTitleUI';
import ScannerCode from '../../../../components/UI/ScannerCode';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import InventoryService from '../../../../services/InventoryService';
import { Card, Input, Button } from '../../../../components/UI/ComponentsUI';

const AuditFull = (props) => {
    const [audit, setAudit] = useState();
    const [filter, setFilter] = useStateWithPromise({ inventoryId: props.filter.inventoryId, validationCode: '', cim: '', lotItemNumber: '' });

    const onQrCodeReadHandler = (value) => {
        if (!isNullOrEmpty(value) && value.length > 1) {
            filter.validationCode = value;
            setFilter({ ...filter }).then(() => {
                getAuditItem();
            })
        } else {
            showMessageToastCustom(translate('warning', 'general'), translate('validations.qrCode-invalid'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const onCIMReadHandler = (value) => {
        if (!isNullOrEmpty(value) && value.length > 1) {
            filter.cim = value;
            setFilter({ ...filter }).then(() => {
                getAuditItem();
            })
        } else {
            showMessageToastCustom(translate('warning', 'general'), translate('validations.invalid-field'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            getAuditItem();
        }
    }

    const getAuditItem = () => {
        if (validateInputsRequired('auditForm')) {
            props.getAuditItem(filter, (response) => {
                if (response) {
                    setAudit(response);
                } else {
                    setAudit();
                    showMessageToastCustom(translate('warning', 'general'), translate('validations.item-not-found'), 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                    <SubtitleUI icon="mdi mdi-text-box-search-outline" label={translate('general.menu.audit', 'inventory')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '21px' }}>
                <div className="container">
                    <Card>
                        <div id='auditForm' style={{ padding: '3px', paddingTop: '7px' }}>
                            <div className="input-field no-padding col s12">
                                <ScannerCode onScanner={onCIMReadHandler} className="mdi mdi-barcode-scan posfix disable" />
                                <Input
                                    required={isNullOrEmpty(filter.validationCode) && isNullOrEmpty(filter.lotItemNumber)}
                                    id="cim"
                                    name="cim"
                                    label={translate('inventory:general.cim')}
                                    type="number"
                                    maxLength="20"
                                    value={filter.cim || ''}
                                    onKeyDown={(e) => handleOnKeyDown(e)}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="input-field no-padding col s5">
                                <Input
                                    required={isNullOrEmpty(filter.validationCode) && isNullOrEmpty(filter.cim)}
                                    id="lotItemNumber"
                                    name="lotItemNumber"
                                    label='Nota'
                                    value={filter.lotItemNumber || ''}
                                    type="number"
                                    onChange={onChange}
                                    maxLength="20"
                                />
                            </div>
                            <div className="input-field no-padding col s12">
                                <ScannerCode onScanner={onQrCodeReadHandler} className="mdi mdi-barcode-scan posfix disable" />
                                <Input
                                    required={isNullOrEmpty(filter.lotItemNumber) && isNullOrEmpty(filter.cim)}
                                    label="Codigo Validação"
                                    id="validationCode"
                                    name="validationCode"
                                    type="text"
                                    onChange={onChange}
                                    onKeyDown={(e) => handleOnKeyDown(e)}
                                    value={filter.validationCode || ''}
                                />
                            </div>
                        </div>
                    </Card>
                    <div className="card-action row center" style={{ marginBottom: '0' }}>
                        <Button onClick={getAuditItem} full="true" text={translate('general:search')} />
                    </div>
                </div>
            </div>
            {
                audit &&
                <div className="container-fluid" style={{ marginTop: '40px', }}>
                    <AuditFullDetails data={audit} />
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAuditItem: (filter, callback) => {
            dispatch(InventoryService.getAuditItem(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AuditFull)));
